<template>
  <card class="stacked-form" title="Change Password">
    <h4 slot="header" class="card-title">Schimba Parola</h4>
    <form ref="password_form" @submit.prevent>
      <div>
        <base-input v-model="credentials.current_pass" label="Parola curenta" type="password" placeholder="Parola curenta"/>
        <base-input v-model="credentials.new_pass" label="Parola noua" type="password" placeholder="Parola noua"/>
        <base-input v-model="credentials.confirm_new_pass" label="Confirma parola" type="password" placeholder="Confirma Parola"/>
        <base-button class="mt-3" native-type="submit" type="primary" @click="changePassword()"
        >Salveaza</base-button
        >
      </div>
    </form>
  </card>
</template>
<script>
  import axios from 'axios';

  export default {
    name: "edit-password-card",

    props: {
      user: Object
    },

    data() {
      return {
        credentials: {
          current_pass: "",
          new_pass: "",
          confirm_new_pass: "",
        }
      }
    },

    methods: {
      changePassword() {
        if (this.passwordValidation()) {
          axios.post('profile/change-password', this.credentials)
                  .then(res => {
                    this.notifySuccess();
                  })
                  .catch(err => {
                    console.log(err);
                  })
        }
      },
      passwordValidation() {
        let testNewPass = /^(?=.*?[A-Z])(?=.*?[0-9]).{6,}$/.test(this.credentials.new_pass);
        if (!testNewPass) {
          this.$notify({
            type: "danger",
            icon: 'tim-icons icon-bell-55',
            message: "Parola trebuie sa contina minim 6 caractere, o litera mare si minim un numar",
          });
          return false;
        } else if (this.credentials.new_pass !== this.credentials.confirm_new_pass) {
          this.$notify({
            type: "danger",
            icon: 'tim-icons icon-bell-55',
            message: "Parola noua si parola confirmata nu sunt identice",
          });
          return false;
        } else if (this.credentials.current_pass === "") {
          this.$notify({
            type: "danger",
            icon: 'tim-icons icon-bell-55',
            message: "Trebuie sa introduci parola curenta",
          });
          return false;
        }
        return true;
      },
      notifySuccess() {
        this.$notify({
          type: 'success',
          message: 'Modificarile au fost salvate cu succes',
          icon: 'tim-icons icon-bell-55',
        })
      }
    }
  };
</script>